import { z } from "zod";
import { PROJECT_VENUS_MODEL, VENUS_DEEP_SPACE_MODEL, VENUS_NOVA_MODEL, VENUS_QWEN38_QUASAR_MODAL_MODEL, } from "./self-hosted-experiment.js";
/**
 * The model gateway's answers about Venus on Modal for the tenant, which holds no Venus
 * credential: whether a model's exact artifact is serving, how its containers are starting, and
 * how long until an idle container sleeps.
 */
export const VENUS_GATEWAY_READINESS_PATH = "/v1/venus/readiness";
export const VENUS_GATEWAY_STARTUP_PATH = "/v1/venus/startup";
export const VENUS_GATEWAY_IDLE_PATH = "/v1/venus/idle";
/** The Modal-served Venus routes the tenant admits sessions to. */
export const venusModalRouteModelSchema = z.enum([
    PROJECT_VENUS_MODEL,
    VENUS_NOVA_MODEL,
    VENUS_QWEN38_QUASAR_MODAL_MODEL,
    VENUS_DEEP_SPACE_MODEL,
]);
export const venusGatewayReadinessRequestSchema = z.object({
    model: venusModalRouteModelSchema,
    /** An admitted harness evaluation: the gateway probes that evaluation's own binding. */
    evaluationHarness: z.enum(["electric", "venus-native"]).optional(),
}).strict();
export const venusGatewayReadinessSchema = z.object({
    contract: z.literal("mlx.venus.gateway-readiness.v1"),
    ready: z.boolean(),
    /** The model the parent endpoint must serve: the route's own, or the bound parent's. */
    servedModel: z.string().min(1),
    /** Deep Space's explorer model; null on other routes. */
    explorerModel: z.string().min(1).nullable(),
}).strict();
/** A startup or inactivity observation of one route's containers. */
export const venusGatewayObservationRequestSchema = z.object({ model: venusModalRouteModelSchema }).strict();
